import Box from "@mui/material/Box";
import Link from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { MenuBar } from "./MenuBar";
import { useStyles } from "./TextEditor.styles";

interface Props {
  onChange: (text: string) => void;
  value?: string;
  "data-test-id"?: string;
}

export const TextEditor = ({
  onChange,
  value,
  "data-test-id": dataTestId,
}: Props) => {
  const classes = useStyles();

  const editor = useEditor({
    extensions: [StarterKit, Underline, Link],
    content: value || "",
    onUpdate: ({ editor }) => onChange(editor.getHTML()),
  });

  return (
    <Box className={classes.textEditor}>
      <MenuBar editor={editor} />
      <EditorContent
        editor={editor}
        className={classes.ProseMirror}
        data-test-id={dataTestId}
      />
    </Box>
  );
};
